export default (theme) => {
  const { maxContentWidth } = theme.global

  return {
    container: {
      padding: theme.spacing(0, 4),
      position: 'relative',
      zIndex: 2,
    },
    wrapper: {
      maxWidth: maxContentWidth,
      margin: theme.spacing(0, 'auto'),
      padding: theme.spacing(1, 0),
      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-start',
      },
    },
    icon: {
      width: 35,
      height: 35,
      marginRight: theme.spacing(2),
    },
    text: {
      '& p': {
        display: 'inline',
      },
      '& a': {
        color: theme.palette.common.darkGrey,
        textDecoration: 'underline',
      },
      [theme.breakpoints.down('sm')]: {
        '& p': {
          display: 'inherit',
        },
      },
    },
    closeButton: {
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
  }
}
